import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useSettings } from "@/context/SettingsContext";

export default function MentionsLegales() {
  const { settings } = useSettings();
  const company = settings?.company_name || "DAS SIMAO AUTO";
  const manager = settings?.manager_name || "Arnaud Simao";
  const email = settings?.email || "contact.dassimaoauto@gmail.com";
  const phone = settings?.phone || "06 45 14 29 65";
  const address = settings?.address_line1
    ? `${settings.address_line1}${settings.address_line2 ? ", " + settings.address_line2 : ""}, ${settings.postal_code || ""} ${settings.city || ""}, ${settings.country || "France"}`
    : "Adresse à préciser dans les paramètres";
  const siret = settings?.siret || "Numéro SIRET à préciser";
  const vat = settings?.vat_number || "";

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="mentions-page">
      <SEO title="Mentions légales" description="Mentions légales du site DAS SIMAO AUTO." />
      <Header />
      <article className="pt-32 pb-20 max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.5em] gold uppercase">Légal</div>
        <h1 className="mt-3 font-serif text-white text-5xl leading-tight">Mentions légales</h1>

        <div className="mt-10 space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-white">Éditeur du site</h2>
            <div className="mt-3 text-[15px] space-y-1">
              <div><b>Raison sociale :</b> {company}</div>
              <div><b>Gérant / Directeur de publication :</b> {manager}</div>
              <div><b>Adresse :</b> {address}</div>
              <div><b>Téléphone :</b> {phone}</div>
              <div><b>Email :</b> <a className="gold underline" href={`mailto:${email}`}>{email}</a></div>
              <div><b>SIRET :</b> {siret}</div>
              {vat && <div><b>TVA intracommunautaire :</b> {vat}</div>}
            </div>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-white">Hébergement</h2>
            <div className="mt-3 text-[15px]">
              Ce site est hébergé par Emergent (emergent.sh) — infrastructure
              managée sur Kubernetes.
            </div>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-white">Propriété intellectuelle</h2>
            <p className="mt-3 text-[15px]">
              L'ensemble du contenu de ce site (textes, images, logo, code)
              est la propriété exclusive de {company} ou de ses partenaires.
              Toute reproduction, même partielle, est strictement interdite
              sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-white">Crédits</h2>
            <p className="mt-3 text-[15px]">
              Photographies illustratives : Pexels & Unsplash (licences
              libres). Icônes : Lucide (MIT). Polices : Playfair Display &
              Outfit (SIL Open Font License).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-white">Contact</h2>
            <p className="mt-3 text-[15px]">
              Pour toute question relative au site ou à ses contenus :{" "}
              <a href={`mailto:${email}`} className="gold underline">{email}</a>.
            </p>
          </section>
        </div>
      </article>
      <Footer />
    </div>
  );
}
